<template>
  <div>
    <el-dialog
      :title="dataType == 1 ? '选择平台类目' : dataType == 3 ? '选择自定义类目' : '选择店铺类目'"
      :visible="showModal"
      :mask-closable="false"
      @close="handleCancel"
      width="1002px"
      append-to-body
      draggable
      :body-style="{ padding: '0px' }"
    >
      <div class="categoryTree">
        <div class="categoryTree-left">
          <div class="categoryTree-left-top">
            <el-input
              v-model="searchKeyword"
              placeholder="请输入关键字搜索"
              size="mini"
              clearable
              style="width: 200px"
            >
              <i
                v-if="!searchKeyword"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i>
            </el-input>
            <el-checkbox
              class="ml20"
              v-model="allChecked"
              @change="handleAllChange"
            >
              全选
            </el-checkbox>
            <el-checkbox
              class="ml20"
              v-model="reverseChecked"
              @change="handleReverseChange"
            >
              反选
            </el-checkbox>
          </div>
          <div class="categoryTree-left-main">
            <div
              class="categoryTree-left-main-item"
              v-for="(column, index) in categoryColumns"
              :key="index"
            >
              <div class="categoryTree-left-main-item-label">
                {{ numberToChinese(index + 1) }}级类目
              </div>
              <div class="categoryTree-left-main-item-checkbox">
                <el-checkbox-group
                  v-if="column.length > 0"
                  class="categoryTree-left-main-item-checkbox-group"
                  v-model="checkedColumns[index]"
                >
                  <div
                    :class="[
                      'categoryTree-left-main-item-checkbox-group-item',
                      {
                        noChildren: !item.children,
                        active: item.value == currentlySelectedList[index],
                      },
                    ]"
                    v-for="item in column"
                    :key="item.value"
                  >
                    <el-checkbox
                      :label="item.value"
                      :indeterminate="getIndeterminate(item)"
                      @change="changeChecked(item, $event)"
                    >
                    </el-checkbox>
                    <div
                      class="checkbox-labels"
                      @click="selectColumn(item, index)"
                    >
                      <el-tooltip
                        effect="dark"
                        :content="item.label"
                        placement="top"
                      >
                        <div
                          class="checkbox-label"
                          :class="{
                            active: item.value == currentlySelectedList[index],
                          }"
                        >
                          {{ item.label }}
                        </div>
                      </el-tooltip>
                      <div
                        v-if="item.children && item.children.length > 0"
                        class="checkbox-labels__icon"
                      >
                        <i
                          class="el-icon-arrow-right"
                          style="font-size: 12px"
                        ></i>
                      </div>
                    </div>
                  </div>
                </el-checkbox-group>
                <div class="noCategoryTree" v-else>
                  请选择{{ numberToChinese(index + 1) }}级类目
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="categoryTree-right">
          <div class="categoryTree-right-top">
            <div class="categoryTree-right-top-left">
              <span>已选</span>
              <span class="categoryTree-right-top-left__num">{{
                selectedList.length
              }}</span>
              <span>个末级类目</span>
            </div>
            <bi-button @click="handleClear()" type="blueText">清空</bi-button>
          </div>
          <div class="categoryTree-right-list" v-if="selectedList.length">
            <div
              class="categoryTree-right-list-item"
              v-for="item in selectedList"
              :key="item.value"
            >
              <el-tooltip effect="dark" :content="item.label" placement="top">
                <span class="categoryTree-right-list-item__label">{{
                  item.label
                }}</span>
              </el-tooltip>
              <div
                @click="handleRemove(item)"
                class="categoryTree-right-list-item__icon"
              >
                <i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="footerBtnBox">
          <!-- 移除了全局应用的复选框，让按钮居右对齐 -->
          <div style="flex: 1"></div>
          <span>
            <bi-button @click="handleSure" type="blue">确定</bi-button>
            <bi-button @click="handleCancel" type="gley">取消</bi-button>
          </span>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    dataType: {
      type: Number,
      default: 1,
    },
    value: {
      type: [String, Array],
      default: "",
    },
    categoryData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      categoryColumns: [], // 动态列
      checkedColumns: [], // 动态选中
      checkedLeafIds: [],
      searchKeyword: "",
      filterCategoryData: [], // 搜索后的树
      isSearch: false,
      reverseChecked: false,
      currentlySelectedList: [], // 用于高亮当前选中项
    };
  },
  watch: {
    showModal(val) {
      if (val) {
        this.init();
      }
    },
    searchKeyword(val) {
      if (!val) {
        this.isSearch = false;
        this.categoryColumns = [this.categoryData, [], []];
        this.currentlySelectedList = []
        this.refreshChecked();
        return;
      }
      this.isSearch = true;
      this.filterCategoryData = this.filterTree(this.categoryData, val);
      this.categoryColumns = this.buildSearchColumns(this.filterCategoryData);
      this.categoryColumns.forEach((item, index) => {
        if (index == this.categoryColumns.length - 1) {
          return;
        }
        this.$set(this.currentlySelectedList, index, item[0].value);
      });
      this.refreshChecked();
    },
  },
  computed: {
    selectedList() {
      let result = [];
      const loop = (list) => {
        list.forEach((item) => {
          if (item.children && item.children.length) {
            loop(item.children);
          } else {
            if (this.checkedLeafIds.includes(item.value)) {
              result.push(item);
            }
          }
        });
      };
      loop(this.categoryData);
      return result;
    },
    // 当前作用域所有末级节点
    allLeafIds() {
      const source = this.isSearch
        ? this.filterCategoryData
        : this.categoryData;

      return this.getAllLeafIds(source);
    },
    // 全选状态
    allChecked: {
      get() {
        return (
          this.allLeafIds.length > 0 &&
          this.allLeafIds.every((id) => this.checkedLeafIds.includes(id))
        );
      },
      set() {},
    },
  },
  methods: {
    numberToChinese(num) {
      const chinese = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十",
        "二十一",
        "二十二",
        "二十三",
        "二十四",
        "二十五",
        "二十六",
        "二十七",
        "二十八",
        "二十九",
        "三十",
      ];
      return chinese[num - 1] || num;
    },
    // 搜索树
    filterTree(list, keyword) {
      let result = [];
      list.forEach((item) => {
        let children = [];
        if (item.children && item.children.length) {
          children = this.filterTree(item.children, keyword);
        }
        const match = item.label.includes(keyword);
        if (match || children.length) {
          result.push({
            ...item,
            // 搜索结果展示
            children: match ? item.children : children,
            // 保存完整树
            _children: item.children,
          });
        }
      });
      return result;
    },
    // 获取显示子节点
    getShowChildren(item) {
      return item.filterChildren?.length ? item.filterChildren : item.children;
    },
    // 构建搜索列
    buildSearchColumns(tree) {
      const columns = [];
      let current = tree;
      while (current && current.length) {
        columns.push(current);
        // 默认展开第一个节点
        const first = current[0];
        if (first.children && first.children.length) {
          current = first.children;
        } else {
          break;
        }
      }
      // 不足三级补空
      while (columns.length < 3) {
        columns.push([]);
      }
      return columns;
    },
    // 初始化
    init() {
      this.categoryColumns = [this.categoryData, [], []];
      this.checkedLeafIds = [...this.value];
      this.refreshChecked();
    },
    // 切换选中项
    changeChecked(item, checked) {
      const leafIds = this.getLeafIds(item);
      if (checked) {
        this.checkedLeafIds = [
          ...new Set([...this.checkedLeafIds, ...leafIds]),
        ];
      } else {
        this.checkedLeafIds = this.checkedLeafIds.filter(
          (id) => !leafIds.includes(id),
        );
      }
      // 手动修改后取消反选状态
      this.reverseChecked = false;
      this.refreshChecked();
    },
    // 刷新选中项
    refreshChecked() {
      this.checkedColumns = this.categoryColumns.map((column) => {
        return this.getLevelChecked(column);
      });
    },
    // 获取当前列选中项
    getLevelChecked(list) {
      let arr = [];
      list.forEach((item) => {
        if (this.isAllChecked(item)) {
          arr.push(item.value);
        }
      });
      return arr;
    },
    // 判断是否半选
    getIndeterminate(item) {
      if (!item.children || !item.children.length) {
        return false;
      }
      const ids = this.getLeafIds(item);
      const checked = ids.filter((id) => this.checkedLeafIds.includes(id));
      return checked.length > 0 && checked.length < ids.length;
    },
    // 判断是否全选
    isAllChecked(item) {
      if (!item.children || !item.children.length) {
        return this.checkedLeafIds.includes(item.value);
      }
      const ids = this.getLeafIds(item);
      return ids.length && ids.every((id) => this.checkedLeafIds.includes(id));
    },
    // 获取叶子节点id
    getLeafIds(item) {
      let ids = [];
      const loop = (list) => {
        list.forEach((v) => {
          if (v.children && v.children.length) {
            loop(v.children);
          } else {
            ids.push(v.value);
          }
        });
      };
      // 搜索状态
      if (this.isSearch) {
        if (item.children && item.children.length) {
          loop(item.children);
        } else {
          ids.push(item.value);
        }
      } else {
        // 正常状态
        if (item.children && item.children.length) {
          loop(item.children);
        } else {
          ids.push(item.value);
        }
      }
      return ids;
    },
    // 选择列
    selectColumn(item, index) {
      if (!item.children?.length) {
        return;
      }
      // 当前点击层的下一列
      this.$set(this.categoryColumns, index + 1, this.getShowChildren(item));
      this.$set(this.currentlySelectedList, index, item.value);
      // 清掉后面的列
      this.categoryColumns.splice(index + 2);
      // 始终保留三级
      while (this.categoryColumns.length < 3) {
        this.categoryColumns.push([]);
      }
      this.refreshChecked();
    },
    // 全选
    handleAllChange(val) {
      const ids = this.allLeafIds;
      if (val) {
        // 全选当前展示数据
        this.checkedLeafIds = [...new Set([...this.checkedLeafIds, ...ids])];
      } else {
        // 取消当前展示数据
        this.checkedLeafIds = this.checkedLeafIds.filter(
          (id) => !ids.includes(id),
        );
      }
      this.reverseChecked = false;
      this.refreshChecked();
    },
    // 获取所有叶子节点id
    getAllLeafIds(list) {
      let ids = [];
      list.forEach((item) => {
        if (item.children?.length) {
          ids.push(...this.getAllLeafIds(item.children));
        } else {
          ids.push(item.value);
        }
      });
      return ids;
    },
    // 反选选择
    handleReverseChange(val) {
      const ids = this.allLeafIds;
      const checkedIds = this.checkedLeafIds.filter((id) => ids.includes(id));
      const unCheckedIds = ids.filter(
        (id) => !this.checkedLeafIds.includes(id),
      );
      this.checkedLeafIds = [
        ...this.checkedLeafIds.filter((id) => !ids.includes(id)),
        ...unCheckedIds,
      ];
      this.refreshChecked();
    },
    // 删除选择
    handleRemove(item) {
      this.checkedLeafIds = this.checkedLeafIds.filter(
        (id) => id !== item.value,
      );
      this.refreshChecked();
    },
    // 清空选择
    handleClear() {
      this.checkedLeafIds = [];
      this.refreshChecked();
    },
    // 确认选择
    handleSure() {
      this.currentlySelectedList = [];
      this.$emit("update:showModal", false);
      this.$emit("confirm", this.checkedLeafIds);
    },
    // 取消选择
    handleCancel() {
      this.currentlySelectedList = [];
      this.searchKeyword = "";
      this.$emit("update:showModal", false);
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.el-dialog .el-dialog__body) {
  padding: 0px;
}
.categoryTree {
  overflow: hidden;
  height: 643px;
  display: flex;
  &-left {
    height: 100%;
    flex: 1;
    border-right: 1px solid #f5f5f7;
    padding: 24px 16px 30px 24px;
    &-main {
      height: calc(100% - 46px);
      border-radius: 4px;
      border: 1px solid #edeff2;
      margin-top: 16px;
      width: 632px;
      overflow-x: auto;
      display: flex;
      &::-webkit-scrollbar {
        height: 4px;
      }
      &-item {
        box-sizing: border-box;
        width: 210px;
        flex-shrink: 0;
        border-left: 1px solid #edeff2;
        &-label {
          background-color: #f4f4f4;
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #edeff2;
          text-align: center;
          font-weight: 600;
          color: #333333;
        }
        &-checkbox {
          padding: 12px 0px;
          height: calc(100% - 40px);
          overflow-y: auto;
          overflow-x: hidden;
          &-group {
            &-item {
              display: flex;
              align-items: center;
              height: 36px;
              line-height: 36px;
              color: #333;
              padding: 0px 12px;
              white-space: nowrap;
              :deep(.el-checkbox) {
                display: flex;
                align-items: center;
              }
              :deep(.el-checkbox__label) {
                display: none;
              }
              .checkbox-labels {
                margin-left: 10px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &__icon {
                  height: 100%;
                  color: #666;
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  flex: 1;
                  cursor: pointer;
                }
              }
              .checkbox-label {
                display: block;
                cursor: pointer;
                color: #333;
                font-size: 14px;
                max-width: 146px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &.active {
                  color: #3156ff;
                  font-weight: 600;
                }
              }
              &.noChildren {
                .checkbox-label {
                  max-width: 168px;
                }
              }
              &.active {
                background-color: rgba(49, 86, 255, 0.08);
              }
              &:hover {
                background-color: #f7f8fa;
              }
            }
          }
          .noCategoryTree {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #999;
          }
          &::-webkit-scrollbar {
            width: 2px;
          }
          &::-webkit-scrollbar-thumb {
            background: #efefef;
            border-radius: 2px;
          }
        }
      }
    }
  }
  &-right {
    flex-shrink: 0;
    flex-basis: 330px;
    padding: 24px 24px 30px 16px;
    color: #333;

    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      font-size: 14px;
      border-bottom: 1px solid #edeff2;
      &-left {
        display: flex;
        align-items: center;
        &__num {
          color: #ff7f23;
          margin: 0px 4px;
        }
      }
    }
    &-list {
      height: calc(100% - 36px);
      overflow: auto;
      &::-webkit-scrollbar {
        width: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #efefef;
        border-radius: 2px;
      }
      &-item {
        display: inline-flex;
        align-items: center;
        padding: 8px;
        background-color: #f4f4f4;
        border-radius: 2px;
        margin-top: 16px;
        margin-right: 12px;
        max-width: 258px;
        font-size: 14px;
        &__icon {
          margin-left: 8px;
          cursor: pointer;
        }
        &__label {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
.ml20 {
  margin-left: 20px;
  margin-right: 0px;
}
</style>
